import React from 'react';

import { FormSpy } from 'react-final-form';
import uniq from 'lodash.uniq';

interface Props {
    fields: string[];
    applyAllFieldName: string;
}

export default function ApplyAllFormSpy(props: Props): React.ReactElement {
    const { fields, applyAllFieldName } = props;

    return (
        <FormSpy subscription={{ values: true }}>
            {({ values, form: { change } }) => {
                // This logic is to watch Apply All radio, it should be checked when all field values are the same
                const fieldValues = fields.map((name) => values[name]);
                const unique = uniq(fieldValues).length === 1;

                if (!unique && values[applyAllFieldName]) {
                    // TODO: Hack to avoid changing state while rendering
                    setTimeout(() => change(applyAllFieldName, undefined), 0);
                    return null;
                }

                if (
                    (unique && values[applyAllFieldName] === fieldValues[0]) ||
                    (!unique && !values[applyAllFieldName])
                ) {
                    return null;
                }
                // TODO: Hack to avoid changing state while rendering
                setTimeout(() => change(applyAllFieldName, fieldValues[0]), 0);

                return null;
            }}
        </FormSpy>
    );
}
